<script lang="ts" setup>
  import { useCurrentConfirmation, useTranslator } from '@othercommerce/foundation';
  import { computed } from 'vue';

  const confirmation = useCurrentConfirmation();
  const translator = useTranslator();
  const open = computed(() => !!confirmation.value);

  const title = computed(() => {
    return confirmation.value?.title || translator.trans('SHOP.COMMON.HEADER.DATA_REMOVAL');
  });

  const description = computed(() => {
    return confirmation.value?.description || translator.trans('SHOP.COMMON.MESSAGE.DATA_REMOVAL');
  });

  const accept = computed(() => confirmation.value?.yes || translator.trans('SHOP.ACTION.YES'));
  const reject = computed(() => confirmation.value?.no || translator.trans('SHOP.ACTION.NO'));

  const processing = computed(() => {
    if (confirmation.value) {
      return confirmation.value.processing;
    } else {
      return false;
    }
  });

  function submit() {
    if (confirmation.value) {
      confirmation.value.confirm();
    }
  }

  function cancel() {
    if (confirmation.value) {
      confirmation.value.cancel();
    }
  }
</script>
<template>
  <UiModal :open="open" class="confirmation" medium>
    <SfHeading headingStyle type="span">
      {{ title }}
    </SfHeading>
    <p class="message" v-html="description" />
    <UiButtonGroup class="actions" end>
      <SfButton :text="reject" smaller @click="cancel" />
      <SfButton :loading="processing" :text="accept" danger smaller @click="submit" />
    </UiButtonGroup>
  </UiModal>
</template>
<style lang="scss" scoped>
  .confirmation {
    //.title, .message {
    //  font-size: 0.875rem !important;
    //  line-height: 1.5 !important;
    //}
    //
    //.title {
    //  font-size: 1rem !important;
    //}

    .actions {
      margin-top: 1rem;
    }

    :deep(.btn) {
      min-width: 6rem;
    }
  }
</style>
